export default {
  unstyled: true,
  pt: {
    calendar: {
      root: { class: "dcf-input-group" },
      dropdownButton: { root: { class: "dcf-input-group-addon dcf-btn dcf-btn-secondary" } },
      panel: { class: "dcf-card dcf-b-solid dcf-b-1 unl-b-gray" },
      header: { class: "dcf-d-flex dcf-w-100%" },
      previousButton: { class: "dcf-btn dcf-btn-tertiary" },
      title: { class: "dcf-flex-1 dcf-txt-center" },
      monthTitle: { class: "dcf-btn dcf-btn-tertiary" },
      yearTitle: { class: "dcf-btn dcf-btn-tertiary" },
      nextButton: { class: "dcf-btn dcf-btn-tertiary" },
      table: { class: "dcf-w-100%" },
      tableheadercell: { class: "dcf-txt-center" },
      day: { class: "" },
      daylabel: { class: "dcf-btn dcf-btn-tertiary" },
      monthpicker: { class: "dcf-grid dcf-grid-thirds" },
      month: { class: "dcf-btn dcf-btn-tertiary" },
      yearpicker: { class: "dcf-grid dcf-grid-thirds" },
      year: { class: "dcf-btn dcf-btn-tertiary" }
    },
    dropdown: {
      root: { class: "dcf-d-flex dcf-input-group" },
      input: { class: "dcf-flex-1 dcf-input-group-addon unl-bg-cream dcf-txt-left" },
      trigger: { class: "dcf-input-group-addon" },
      panel: { class: "dcf-card dcf-b-solid dcf-b-1 unl-b-gray dcf-overflow-y-scroll" },
      virtualScroller: { class: "" },
      list: { class: "dcf-list-bare" },
      item: function(ctx){ 
        return { class: ["dcf-pl-1 dcf-mb-0 dcf-pb-1 ianrmedia-hover-highlight", 
          { "dcf-bold unl-bg-lighter-gray": (ctx.context.selected) } 
        ], style: "cursor: pointer"
        } 
      }
    },
    multiselect: {
      root: { class: "dcf-w-100% dcf-w-max-100% dcf-d-flex dcf-input-group" },
      labelContainer: { class: "dcf-flex-1 dcf-input-group-addon unl-bg-cream dcf-txt-left" },
      label: { class: "dcf-txt-nowrap dcf-overflow-x-hidden dcf-truncate" },
      trigger: { class: "dcf-input-group-addon" },
      panel: { class: "dcf-card dcf-b-solid dcf-b-1 unl-b-gray dcf-overflow-y-scroll" },
      header: { class: "dcf-d-flex" },
      list: { class: "dcf-list-bare" },
      item: { class: "dcf-input-checkbox dcf-d-flex" },
      option: { class: "dcf-pl-4" }
    },
    checkbox: {
      root: { class: "" },
      box: { class: " dcf-b-solid dcf-b-1 unl-b-gray dcf-w-5 dcf-h-5 dcf-ml-1" },
      checkbox: { class: "" },
    },
    toast: {
      root: { class: "dcf-left-0 dcf-right-0" },
      content: function(ctx){
        return {
          class: ["dcf-notice dcf-d-grid dcf-mb-6 dcf-ml-auto dcf-mr-auto dcf-w-max-lg", 
            {
              "dcf-notice-info" : (ctx.props.message.severity == 'info'),
              "dcf-notice-success" : (ctx.props.message.severity == 'success'),
              "dcf-notice-warning" : (ctx.props.message.severity == 'warn'),
              "dcf-notice-danger" : (ctx.props.message.severity == 'error'),
            }
          ]
        }
      },
      icon: { class: "dcf-notice-icon dcf-h-100% dcf-w-100% dcf-notice-message" },
      text: { class:"dcf-notice-body dcf-notice-message"},
      summary: { class: "dcf-notice-heading dcf-txt-h6 dcf-mb-0" },
      detail: { class: "" },
      buttonContainer: { class:"dcf-notice-close"},
      button: { class: "dcf-btn dcf-btn-inverse-tertiary dcf-lh-1" }
    },
    tabview: {
      root: { class: "dcf-tabs" },
      nav: { class: "dcf-tabs-list dcf-list-bare dcf-mb-0" },
      inkbar: { class: "dcf-relative dcf-h-0 dcf-m-0" }
    },
    tabpanel: {
      root: { class: "bar" },
      header: { class: 'dcf-tabs-list-item dcf-mb-0' },
      headerAction: { class: 'dcf-tab dcf-d-block' },
      headerTitle: { class: 'dcf-txt-h6 dcf-h-1' },
      content: { class: 'dcf-tabs-panel' }
    }

  }

}

